import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Receipt } from 'lucide-react';

/** Card campi specifici Fattura/Nota di credito (SDI). onChange(patch) fa merge su dati_fattura. */
export const DatiFatturaCard = ({ dati, onChange }) => (
  <Card className="rounded-md border-emerald-500/30 bg-emerald-500/5">
    <CardHeader className="pb-2">
      <CardTitle className="text-sm font-mono uppercase flex items-center gap-2">
        <Receipt className="h-4 w-4 text-emerald-500" />
        Dati Fatturazione
        <Badge variant="outline" className="ml-2 text-[10px]">Integrazione XML in arrivo</Badge>
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label className="text-xs font-mono uppercase">Codice SDI (7 car.)</Label>
          <Input
            value={dati.codice_destinatario_sdi}
            onChange={(e) => onChange({ codice_destinatario_sdi: e.target.value.toUpperCase() })}
            className="rounded-md font-mono"
            maxLength={7}
            placeholder="0000000"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">PEC Destinatario</Label>
          <Input
            type="email"
            value={dati.pec_destinatario}
            onChange={(e) => onChange({ pec_destinatario: e.target.value })}
            className="rounded-md"
            placeholder="pec@esempio.it"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Scadenza Pagamento</Label>
          <Input
            type="date"
            value={dati.data_scadenza_pagamento}
            onChange={(e) => onChange({ data_scadenza_pagamento: e.target.value })}
            className="rounded-md"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-xs font-mono uppercase">Rif. DDT</Label>
          <Input
            value={dati.riferimento_ddt}
            onChange={(e) => onChange({ riferimento_ddt: e.target.value })}
            className="rounded-md"
            placeholder="Numero DDT di riferimento"
          />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Rif. Ordine Cliente</Label>
          <Input
            value={dati.riferimento_ordine}
            onChange={(e) => onChange({ riferimento_ordine: e.target.value })}
            className="rounded-md"
            placeholder="Numero ordine cliente"
          />
        </div>
      </div>
      <div className="p-3 bg-muted/50 rounded-md text-xs text-muted-foreground">
        <p className="font-medium mb-1">Integrazione Fattura Elettronica</p>
        <p>I campi SDI e PEC verranno utilizzati per la futura integrazione con Fatture in Cloud, Aruba o TeamSystem per l&apos;invio automatico della fattura elettronica XML al Sistema di Interscambio.</p>
      </div>
    </CardContent>
  </Card>
);
